<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Alterar senha</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form @submit.prevent="changePassword" autocomplete="off">
          <div class="row">
              <div class="col-md-6" :class="{'has-danger': errors.has('senha')}">
                  <div class="form-group">
                      <label for="senha">Nova Senha</label>
                      <input id="senha" name="senha" class="form-control"
                        v-validate="'required'" ref="senha"
                        v-model="senha">
                      <div v-if="errors.has('senha')" class="help-block form-text text-muted form-control-feedback">
                        {{errors.first('senha')}}
                      </div>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-md-6" :class="{'has-danger': errors.has('novaSenha')}">
                  <div class="form-group">
                      <label for="novaSenha">Reptir Nova Senha</label>
                      <input id="novaSenha" name="novaSenha" class="form-control"
                        v-validate="'required|confirmed:senha'"
                        v-model="novaSenha">
                      <div v-if="errors.has('novaSenha')" class="help-block form-text text-muted form-control-feedback">
                        {{errors.first('novaSenha')}}
                      </div>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col text-right mb-2">
                <div class="btn-login">
                  <button type="button" @click.stop.prevent="$emit('changeTo', 'login')" class="btn btn-outline-secondary" data-dismiss="modal">Voltar</button>
                  <button type="submit" class="btn btn-primary">Recuperar</button>
                </div>
              </div>
          </div>
      </form>
    </div>
  </div>
</template>
<script>
import * as http from 'axios'

export default {
  data () {
    return {
      senha: null,
      novaSenha: null
    }
  },
  methods: {
    async changePassword () {
      this.$validator.validateAll()
        .then(async result => {
          if (result) {
            var payload = {
              token: this.$route.query.recover,
              novaSenha: this.senha
            }
            try {
              await http.post('/auth/changePassword', payload)
              window.$('#drAcheiModal').modal('hide')
              this.$store.dispatch('showSuccessMsg', {
                body: 'Senha alterada com sucesso!'
              })
            } catch (error) {
              this.$toasted.show('Falha ao alterar senha, favor tente novamente!', {
                icon: { name: 'fa-exclamation-triangle' },
                type: 'error',
                theme: 'bubble',
                action: {
                  text: 'FECHAR',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                }
              })
            }
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue